export const FETCH_EVENTS_DATA = 'FETCH_EVENTS_DATA'
export const EVENTS_DATA_REQUEST = 'EVENTS_DATA_REQUEST'


// WEBPACK FOOTER //
// ./src/constants/events.js